<template>
  <Head>
    <title>{{ title ? `${title} - ONE Audiobooks` : 'ONE Audiobooks' }}</title>
  </Head>
</template>

<script>
  import { Head } from '@inertiajs/inertia-vue3';

  export default {
    components: {
      Head,
    },
    props: {
      title: String,
      default: '',
    },
  };
</script>
